import { get } from 'svelte/store';
import { activeMatch, currentScreen, fullScreenBoard, lastBallState, peerRole } from '../svelte/store.js';
import { appSettings } from '../store.js';
import { PeerSync } from '../peer-sync.js';
import { broadcastBallViaSupabase } from './supabase-fallback.js';

export function sendCurrentMatchState() {
  if (appSettings.autoSyncEnabled === false) return false;
  const match = get(activeMatch);
  if (get(peerRole) !== 'scorer' || !match) return false;
  const snapshot = PeerSync.buildStateSnapshot(match, {
    board: get(fullScreenBoard),
    screen: get(currentScreen),
    revision: match._stateRevision || 0,
    lastBall: get(lastBallState)
  });
  if (!snapshot) return false;
  if (PeerSync.isConnected) {
    PeerSync.sendState(snapshot);
  }
  broadcastBallViaSupabase(snapshot);
  return true;
}

